import React from 'react'
import ErrorBoundaryFallbackComponent from './ErrorBoundaryFallbackComponent'

class ErrorBoundary extends React.Component {
    static defaultProps = {
        FallbackComponent: ErrorBoundaryFallbackComponent
    }

    state = {
        error: null,
        info: null
    }

    componentDidCatch(error, info) {
        const { onError } = this.props

        if (typeof onError === 'function') {
            try {
                onError.call(this, error, info ? info.componentStack : '')
            } catch (ignoredError) {}
        }

        this.setState({ error, info })
    }

    render() {
        const { children, FallbackComponent, title, returnNullIfError } = this.props
        const { error, info } = this.state

        if (error !== null) {
            if (returnNullIfError) {
                return null
            }
            return <FallbackComponent title={title} componentStack={info ? info.componentStack : ''} error={error} />
        }

        return children || null
    }
}

export default ErrorBoundary
